import { createContext, useContext } from 'react';
import { useLevelsData } from '../services/levelsService';
import { buildModuleDefinitions } from '../services/mockData';

const LevelsContext = createContext({ modules: [], loading: true });

export function LevelsProvider({ children }) {
    const { levelsData, loading } = useLevelsData();
    const modules = levelsData ? buildModuleDefinitions(levelsData.levels) : [];

    return (
        <LevelsContext.Provider value={{ modules, loading }}>
            {children}
        </LevelsContext.Provider>
    );
}

/**
 * Returns the live module definitions array from DB.
 * Replaces static MODULE_DEFINITIONS import in components.
 * @returns {{ modules: Array, loading: boolean }}
 */
export function useModules() {
    return useContext(LevelsContext);
}
